import axios from 'axios'

// Full config:  https://github.com/axios/axios#request-config
let config = {}

const _axios = axios.create(config)

_axios.defaults.headers.common['Pragma'] = 'no-cache'
_axios.defaults.headers.common['Cache-Control'] = 'no-cache'
_axios.defaults.headers.common['Expires'] = '-1'

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response
  },
  function(error) {
    if (error.response.status === 401) {
      // Reloading the page will pull down index.html, which will prompt user for login
      window.location.reload(true)
    }

    return Promise.reject(error)
  }
)

export { _axios }

// export default Plugin
export default {
  install: app => {
    app.config.globalProperties.$axios = _axios
  }
}
